import {PostsFilterStateType} from '../../../../../service/posts/posts-types';
import {TimeType} from '../../../../../util/time';

export function isAnyFilterPresents(filter: PostsFilterStateType): boolean {
    const {sources, statuses, timeRange} = filter;

    return sources.length > 0 || statuses.length > 0 || timeRange.some((time: TimeType) => time !== null);
}
